const md5 = require('md5')
export default ({ app }, inject) => {
  inject('md5', (subprogramId, lotId, creationDate) => {
    return md5((subprogramId + lotId + creationDate))
  })
}
